module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Light-Alphabetic.1f17b4f8.woff";